export default __webpack_public_path__ + "static/media/Send button.86bd4b79.svg";